import { api } from './api';
import type { Account, NicheInfo } from '../types';

export const reviewBankApi = {
  list: (niche?: string, lang?: string) => {
    const qs = new URLSearchParams();
    if (niche) qs.set('niche', niche);
    if (lang) qs.set('lang', lang);
    return api.get<Account[]>(`/review-bank?${qs}`);
  },
  niches: (lang?: string) => {
    const qs = lang ? `?lang=${lang}` : '';
    return api.get<NicheInfo[]>(`/review-bank/niches${qs}`);
  },
  setGrowth: (id: number, growth: number) =>
    api.post(`/review-bank/${id}/growth`, { growth }),
  setNiche: (id: number, niche: string) =>
    api.post(`/review-bank/${id}/niche`, { niche }),
  setType: (id: number, accountType: string) =>
    api.post(`/review-bank/${id}/type`, { account_type: accountType }),
  accept: (id: number) =>
    api.post(`/review-bank/${id}/accept`, {}),
  hide: (id: number, reason?: string) =>
    api.post(`/review-bank/${id}/hide`, { reason }),
};
